import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import {WithModal} from '../';
import {ElectroCell, Electroentry, Electrotable, ElMeterCell} from '../entries'
import * as trends from '../../trends.js';
import styles from './style.css';

const eparsId = ["tc_8_92_200", "tc_8_93_200", "tc_8_97_48", "tc_8_97_49", "tc_8_97_48",
    "tc_8_97_48", "tc_8_97_49", "tc_8_97_49", "tc_8_92_201", "tc_8_93_201",
    "tc_8_90_11", "tc_8_90_17", "tc_8_91_11", "tc_8_91_17", "tc_8_97_61",
    "tc_8_97_62",];
const c1Id = ["ti_8_92_141", "ti_8_92_151", "ti_8_92_142", "ti_8_92_152", "ti_8_92_143", "ti_8_92_153"];
const c2Id = ["ti_8_93_141", "ti_8_93_151", "ti_8_93_142", "ti_8_93_152", "ti_8_93_143", "ti_8_93_153"];

export class Electro extends WithModal {

    render() {
        const chart = super.render();
        let epars = eparsId.map(k => {
            return this.props.params[k]
        });
        let c1 = c1Id.map(k => {
            return this.props.params[k]
        });
        let c2 = c2Id.map(k => {
            return this.props.params[k]
        });

        return (
            <div className={[this.props.className, 'row col-md-12', styles.App].join(' ')}>
                <Electroentry canvas_id={styles.canvas1} ps={epars}/>
                <Electrotable/>
                <ElectroCell openModal={this.openModal.bind(this)} ps={c1}
                             chartPs={[trends.electro_t1, trends.electro_t2]}
                             div_id={styles.canvas3}/>
                <ElectroCell openModal={this.openModal.bind(this)} ps={c2}
                             chartPs={[trends.electro_t3, trends.electro_t4]}
                             div_id={styles.canvas4}/>
                <ElMeterCell ps={this.props.params['ti_8_93_104']} div_id={styles.canvas5}/>
                <ElMeterCell ps={this.props.params['ti_8_92_104']} div_id={styles.canvas6}/>
                {chart}
                <div className={classNames(styles.capt, styles.capt1)}>Ввод №1 от ТП-10/0.4кВ</div>
                <div className={classNames(styles.capt, styles.capt2)}>QS1</div>
                <div className={classNames(styles.capt, styles.capt3)}>QF1</div>
                <div className={classNames(styles.capt, styles.capt4)}>KM1</div>
                <div className={classNames(styles.capt, styles.capt5)}>KV1</div>
                <div className={classNames(styles.capt, styles.capt6)}>1QF</div>
                <div className={classNames(styles.capt, styles.capt7)}>2QF</div>
                <div className={classNames(styles.capt, styles.capt8)}>3QF</div>
                <div className={classNames(styles.capt, styles.capt9)}>4QF</div>
                <div className={classNames(styles.capt, styles.capt10)}>8QF</div>
                <div className={classNames(styles.capt, styles.capt11)}>9QF</div>
                <div className={classNames(styles.capt, styles.capt12)}>KM2</div>
                <div className={classNames(styles.capt, styles.capt13)}>QF2</div>
                <div className={classNames(styles.capt, styles.capt14)}>KV2</div>
                <div className={classNames(styles.capt, styles.capt15)}>QS2</div>
                <div className={classNames(styles.capt, styles.capt16)}>QF1</div>
                <div className={classNames(styles.capt, styles.capt17)}>Ввод №2 от ТП-10/0.4кВ</div>

                <div className={classNames(styles.capt, styles.capt18)}>EK1</div>
                <div className={classNames(styles.capt, styles.capt19)}>ШАТНЦ-1</div>
                <div className={classNames(styles.capt, styles.capt20)}>ШАТНЦ-2</div>
                <div className={classNames(styles.capt, styles.capt21)}>ШУВ-1</div>
                <div className={classNames(styles.capt, styles.capt22)}>ШУВ-2</div>
                <div className={classNames(styles.capt, styles.capt23)}>ЕК2</div>
                <div className={classNames(styles.capt, styles.capt24)}>Насосы <br/> контура генерации</div>
                <div className={classNames(styles.capt, styles.capt25)}>Насосы <br/> контура нагрузки</div>
                <div className={classNames(styles.capt, styles.capt26)}>Вентиляторы <br/> узла ВЕНА</div>

                <div className={classNames(styles.capt, styles.capt_r, styles.capt27)}>1KM</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt28)}>2KM</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt29)}>3KM</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt30)}>4KM</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt31)}>8KM</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt32)}>9KM</div>
                <div className={classNames(styles.capt, styles.capt33)}>AB</div>
                <div className={classNames(styles.capt, styles.capt34)}>KM</div>
                <div className={classNames(styles.capt, styles.capt35)}>AB</div>
                <div className={classNames(styles.capt, styles.capt36)}>KM</div>

                <div className={classNames(styles.capt, styles.capt37)}>H1</div>
                <div className={classNames(styles.capt, styles.capt38)}>H2</div>
                <div className={classNames(styles.capt, styles.capt39)}>H3</div>
                <div className={classNames(styles.capt, styles.capt40)}>H4</div>
                <div className={classNames(styles.capt, styles.capt41)}>B1</div>
                <div className={classNames(styles.capt, styles.capt42)}>B2</div>

                <div className={classNames(styles.capt, styles.capt_r, styles.capt43)}>Терен-50</div>
                <div className={classNames(styles.capt, styles.capt_r, styles.capt44)}>Терен-100</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Electro);



// WEBPACK FOOTER //
// ./src/components/Electro/index.jsx